/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable comma-dangle */
import { Button } from 'crux';
import React from 'react';
import get from 'lodash/get';
import at from 'lodash/at';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import styled, { withTheme } from 'styled-components';
import {
  getEnableContinueBreadCrumb,
  getLoaders,
  getContinueState,
} from '../../redux/selector/validations';
import {
  getNextPage,
  submitAuthQuestion,
  submitSectionQuestion,
  goToPreviousBreadCrumb,
  setOuterListActionButton,
} from '../../redux/actions/questions';
import { addListItem, submitListAnswers } from '../../redux/actions/listQuestion';
import { getCurrentQuestionSet } from '../../redux/selector/questions';
import {
  singleButtonPage,
  buttonLabelMap,
  scrollTop,
  toDashCase,
  isCustomRole,
  useDocumentWidth,
  scrollQuestionIntoView,
} from '../../utils';
import { getListProps } from '../../redux/selector/listQuestion';
import { getCSSVariables, getThemeFromConfig } from '../../cruxComponents/utils';
import SessionStorageServices from '../../util/sessionStorageServices';

const ButtonWrapper = styled.div`
  margin-left: 8px;
  margin-top: 50px;
  @media (max-width: 767px) {
    margin-top: 0px;
  }
`;

const FullWidthButton = styled.div`
  display: flex;
  width: 100%;
  ${({ fullWidthBtnTheme }) => fullWidthBtnTheme || 'flex-direction: row;'}
  justify-content: ${({ fullWidthBtnTheme: { justifyContent } = {} }) =>
    justifyContent || 'center'};

  @media (max-width: 768px) {
    width: 90%;
    ${({ pageId }) => pageId === 'review' && 'max-width: 100% !important;'}
  }
  @media (max-width: 610px) {
    ${({ pageId }) =>
      pageId === 'review' &&
      `
        flex-direction: column !important;
        align-items: center;
        & button {
          margin-top: 15px;
        }
      `}
  }

  & > button {
    width: ${({ fullWidthBtnTheme }) => (fullWidthBtnTheme ? fullWidthBtnTheme.btnWidth : '100%')};
    max-width: 560px;
    &:focus {
      outline: 4px solid #037bb5 !important;
      outline-offset: 1px;
      // border-radius: 1px;
      // For safari browsers because it has issues with outline when border:none;
      border: 0px solid #037bb5 !important;
    }
    @media (max-width: 768px) {
      width: 90%;
      max-width: 340px;
    }
    @media (max-width: 320px) {
      max-width: 280px;
    }
  }
`;

const SubSectionButton = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  ${({ commonBtnTheme = {}, showArrowButton }) =>
    commonBtnTheme?.shape === 'parallelogram'
      ? `${showArrowButton ? '' : 'padding-right: 18px;'}`
      : 'padding-left: 20px;'}
  flex: ${({ isUpdateMode }) => (isUpdateMode ? 4 : 8)};
  ${(props) => props.showInlineButtons && 'flex:none;'};
  @media (max-width: 480px) {
    align-items: normal;
    padding: 0;
    ${({ backButtonHide }) => backButtonHide && 'width: 100%; align-items: flex-end;'}
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    & button {
      ${({ isLastSection }) =>
        !isLastSection
          ? 'padding: 7px 20px;'
          : `
        width: 94%;
        max-width: 342px;
      `}
    }
  }
`;

const PageButton = styled.div`
  @media (min-width: 900px) {
    max-width: 780px;
  }
  width: 100%;
  margin: 0 auto;
  ${(props) => (!props.showInlineButtons ? 'background: #ffffff' : 'padding-right: 0px')};
  justify-content: flex-end;
  ${({ showInlineButtons, pageLayout }) =>
    showInlineButtons && pageLayout === 'single' && 'width: 80%; max-width: 80%'};
  border-radius: 8px;
  display: flex;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  & button {
    &:focus {
      outline: 4px solid #037bb5 !important;
      outline-offset: 1px;
      // border-radius: 1px;
      border: 1px solid transparent !important;
    }
  }
  ${({ isLastSection, showArrowButton }) =>
    (!isLastSection || showArrowButton) &&
    `
    & button {
      border: none;
    }
  `}
  @media (max-width: 767px) {
    padding: 0;
    margin: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
  }
`;

const SubSection = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    & > div,
    & > div > div {
      width: 100%;
    }
  }
  align-items: flex-end;
  ${(props) => !props.showInlineButtons && 'flex:1;'};
  @media (max-width: 767px) {
    align-items: center;
    width: 100%;
  }
`;

const SubSectionLink = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  flex: ${({ isUpdateMode }) => (isUpdateMode ? 4 : '0 auto')};
  ${(props) => props.showInlineButtons && 'flex:none;'};
  @media (max-width: 767px) {
    ${({ pageId, backButtonHide }) =>
      pageId === 'signature' ? 'flex: 4;' : !backButtonHide && 'width: 100%;'}
    & > button {
      max-width: 150px;
      margin-left: 0px;
    }
  }
  @media (max-width: 600px) {
    ${({ pageId }) => pageId === 'signature' && 'flex: 0;'}
  }
  @media (max-width: 480px) {
    ${({ pageId }) =>
      pageId === 'q' &&
      `
      margin-top: 20px;
      & > button {
        width: 100%;
        max-width: 360px;
      }
    `}
  }
`;

/**
 * @description calculates theme configuration
 * @param {Object} props entire props
 * @param {String} button prev/next button
 *
 * @nikhil @swetha Please take care of this. This is a temporary
 * function which calculates back and next button theme configs.
 */
const getThemeConfiguration = (props, button) => {
  const theme = get(props, 'theme.config.theme.global');
  const prevButtonTheme = get(theme, 'prevButtonTheme', {
    themeConfiguration: {},
  });
  const { isLastSection, pageId, showArrowButton } = props;
  const pageOverrides = get(props, 'theme.config.theme.pageOverrides', {});
  const fullWidthBtnTheme = {
    ...(pageOverrides[pageId] ? pageOverrides[pageId].fullWidthButton : { themeConfiguration: {} }),
  };
  const commonBtnTheme = get(theme, 'commonButtonTheme');
  fullWidthBtnTheme.themeConfiguration = {
    ...fullWidthBtnTheme.themeConfiguration,
    ...commonBtnTheme,
  };

  const nextButtonTheme = get(theme, 'nextButtonTheme', {
    themeConfiguration: {},
  });

  const listAddButtonTheme = get(theme, 'listButtonsTheme.listItemAddButtonTheme', {
    themeConfiguration: {},
  });

  const colorOverride = get(props, 'theme.config.theme.global.colorOverride', null);
  const cssVariables = getCSSVariables(props.theme);
  const font = at(cssVariables, ['pageOverride.font', 'global.font']);
  let themeConfiguration = null;

  if (colorOverride) {
    themeConfiguration = {
      selectedBgColor: colorOverride.selectedBgColor,
      bgColor: '#ffffff',
      border: `1px solid ${colorOverride.selectedBgColor}`,
      fontColor: '#333333',
    };
  }
  if (button === 'next' && nextButtonTheme && nextButtonTheme.themeConfiguration) {
    if (!isLastSection || showArrowButton) {
      themeConfiguration = nextButtonTheme.themeConfiguration;
    } else {
      themeConfiguration = fullWidthBtnTheme.themeConfiguration;
    }
    themeConfiguration.font = font?.[0]?.['button-next'] || font?.[1]?.['button-next'];
  }

  if (button === 'prev' && prevButtonTheme) {
    if (isLastSection) {
      themeConfiguration =
        prevButtonTheme.themeConfiguration.linkBtnTheme || prevButtonTheme.themeConfiguration;
    } else {
      themeConfiguration =
        prevButtonTheme.themeConfiguration.arrowBtnTheme || prevButtonTheme.themeConfiguration;
      themeConfiguration.font = font?.[0]?.['button-prev'] || font?.[1]?.['button-prev'];
    }
  }

  if (button === 'add' && listAddButtonTheme && listAddButtonTheme.themeConfiguration) {
    themeConfiguration = listAddButtonTheme.themeConfiguration;
    themeConfiguration.font =
      font?.[0]?.['button-list-item-add'] || font?.[1]?.['button-list-item-add'];
  }

  return themeConfiguration;
};

const ActionButtons = (props) => {
  const {
    pageId,
    actionProps,
    enableContinue,
    handleAuthSubmit,
    handleNextButton,
    handleSectionContinue,
    sectionContinue,
    isList,
    enableAdd,
    handleListAdd,
    handleListSubmit,
    handleListActionFocus,
    processing,
    currentStatus,
    isLastSection,
    handleBackLink,
    otherParams,
    isUpdateMode,
    prevButtonText,
    nextButtonId,
    nextButtonText,
    otherNextButtonText,
    showArrowButton,
    nextButtonDescription,
    handleOtherNextButtonClick,
    redirectUrl,
    listId,
    prevBtnScrollTop,
    sectionData,
    questionList,
    listAddButtonLabel,
    listAddBtnTheme,
    isPopUpOpen,
    value,
    currentBreadcrumbTitle,
    isLoading,
    listEditIndex,
    listEditQId,
    copyAppConfig,
    isNestedQ,
    parentListIndex,
    ...otherProps
  } = props;
  // Label Config for page with single button
  const getSingleButtonLabel = () => {
    if (processing) return 'PROCESSING...';
    if (nextButtonText) return nextButtonText;
    return buttonLabelMap[pageId];
  };

  const getButtonLabel = () => {
    if (processing) return 'Processing';
    if (nextButtonText) return nextButtonText;
    return 'Continue';
  };

  const isListAddorEditMode = () => {
    if (questionList && Array.isArray(questionList) && questionList.length > 1) {
      const listQ = questionList.filter((q) => q.display_type === 'list');
      if (listQ.length) {
        const submissionType = get(listQ[0], 'submission_type');
        // has_items will be false for the first list item
        const hasItems = get(listQ[0], 'has_items', false);
        if (submissionType === 'all' || !hasItems) {
          return false;
        }
        const childQuestionsCompletedFlag = get(listQ[0], 'child_questions_completed_flag');
        const isEditMode = (listEditIndex > -1 && listEditQId) || props.mode === 'listEdit';
        return !childQuestionsCompletedFlag || isEditMode;
      }
    }
    return false;
  };

  const docWidth = useDocumentWidth();

  // check whether action button is used as individual list button or cta button
  const theme = get(props, 'theme.config.theme.global');
  const maxChallengeTries = get(theme, 'maxChallengeTries');
  // retrieve attempt from session if not present in BE response
  const sessionAttempt = SessionStorageServices.getLocalValue('attempt');
  const nextButtonAttemptCount = get(otherParams, 'attempt', +sessionAttempt);
  const isChallengeBtnDisabled =
    currentStatus === 'challenge' &&
    maxChallengeTries &&
    nextButtonAttemptCount >= maxChallengeTries;

  const nextButtonHide = get(otherParams, 'is_next_btn_hidden', false);
  const otherNextButtonHidden = get(otherParams, 'is_other_next_button_hidden', true);
  const backButtonHide = get(otherParams, 'is_prev_btn_hidden', false) || isListAddorEditMode();
  const pageLayout = get(props, 'theme.pageLayout', '');
  const primaryButton = get(props, 'theme.config.theme.global.primaryButton');

  const commonBtnTheme = get(theme, 'commonButtonTheme');
  const showInlineButtons = get(theme, 'showInlineButtons', false);
  const prevButtonTheme = {
    ...get(theme, 'prevButtonTheme', { themeConfiguration: {} }),
    ...commonBtnTheme,
  };
  const nextButtonTheme = {
    ...get(theme, 'nextButtonTheme', { themeConfiguration: {} }),
    ...commonBtnTheme,
  };
  const actionButtonTheme = get(theme, 'actionButtonTheme', {
    themeConfiguration: {},
  });
  const pageOverrides = get(props, 'theme.config.theme.pageOverrides', {});
  const maxWidth = pageOverrides[pageId] && pageOverrides[pageId].maxWidth;
  // eslint-disable-next-line react/destructuring-assignment
  const cssVariables = getCSSVariables(props.theme);
  const buttonDescriptionTheme = getThemeFromConfig(props.theme, 'buttonDescriptionTheme');
  const listItemCardTheme = get(theme, 'listItemCardTheme');
  const exactBtnTheme = get(listItemCardTheme, 'exactBtnTheme', false);

  const ctaBtnThemeResp = get(otherParams, 'buttons.styles', null);
  const ctaBtnTheme = ctaBtnThemeResp &&
    ctaBtnThemeResp.themeConfiguration && {
      ...ctaBtnThemeResp,
      themeConfiguration: {
        ...commonBtnTheme,
        ...ctaBtnThemeResp.themeConfiguration,
      },
    };
  let fullWidthBtnTheme = ctaBtnTheme;

  if (!fullWidthBtnTheme) {
    fullWidthBtnTheme = {
      ...(pageOverrides[pageId]
        ? pageOverrides[pageId].fullWidthButton
        : { themeConfiguration: {} }),
    };
    fullWidthBtnTheme.themeConfiguration = {
      ...fullWidthBtnTheme.themeConfiguration,
      ...commonBtnTheme,
    };
  }

  const _fullBtnWidth = at(cssVariables, [
    'pageOverride.width.actionButton-fullWidthButton',
    'global.width.actionButton-fullWidthButton',
  ]);
  if (!isEmpty(fullWidthBtnTheme)) {
    fullWidthBtnTheme.width = _fullBtnWidth[0] || _fullBtnWidth[1];
  }

  // Handles prev button action
  let prevButtonAction = handleBackLink;
  if (prevBtnScrollTop) prevButtonAction = scrollTop;

  // Handles Action Buttons
  if (!isEmpty(actionProps)) {
    return (
      <>
        <ButtonWrapper>
          <Button
            handleButtonClick={handleSectionContinue}
            actionProps={actionProps}
            color={primaryButton.color}
            disabled={!value || !sectionContinue || processing}
            themeConfiguration={getThemeConfiguration(props, null)}
            {...otherProps}
            {...actionButtonTheme}
          />
        </ButtonWrapper>
      </>
    );
  }

  // Single Button Display Exception Cases
  // Task - https://sureify.atlassian.net/browse/AS-577
  const singleButtonExceptions = () => {
    if (pageId === 'quote' && (!backButtonHide || (backButtonHide && nextButtonHide))) return true;
    return false;
  };

  const getAriaLabel = (buttonLabel) => {
    const pageLabel = currentBreadcrumbTitle || pageId;
    return `${buttonLabel} ${pageLabel}`;
  };

  const handleButtonFocus = (e) => {
    scrollQuestionIntoView({
      element: e.target,
      theme: props.theme,
      screenViewport: props.screenViewport,
    });
  };

  const getContinueButton = () => {
    return (
      <SubSectionButton
        name='page-section-button'
        id='page-section-button'
        isUpdateMode={isUpdateMode}
        showInlineButtons={showInlineButtons}
        commonBtnTheme={commonBtnTheme}
        backButtonHide={backButtonHide}
        showArrowButton={showArrowButton}
        isLastSection={isLastSection}
      >
        <div>
          {isUpdateMode ? (
            <Button
              label='Update'
              id='btn-update'
              type='subsection'
              tabIndex='0'
              disabled={isChallengeBtnDisabled || !enableContinue || processing}
              {...nextButtonTheme}
              themeConfiguration={getThemeConfiguration(props, 'next')}
              handleButtonClick={
                isList
                  ? () => handleListSubmit('CONFIRM_UPDATE')
                  : () => handleSectionContinue('', 'CONFIRM_UPDATE', isList)
              }
              onFocus={handleButtonFocus}
              ariaLabel={getAriaLabel('update')}
            />
          ) : (
            !nextButtonHide && (
              <Button
                shape='rectangle'
                label={getButtonLabel()}
                id={`btn-next-${toDashCase(getButtonLabel())}`}
                color={primaryButton.color}
                {...nextButtonTheme}
                themeConfiguration={getThemeConfiguration(props, 'next')}
                handleButtonClick={
                  isList
                    ? () => {
                        handleListSubmit('');
                      }
                    : () => {
                        handleSectionContinue(nextButtonId, '', nextButtonAttemptCount);
                      }
                }
                onFocus={handleButtonFocus}
                width='100%'
                disabled={isChallengeBtnDisabled || !enableContinue || processing || isPopUpOpen}
              />
            )
          )}
        </div>
      </SubSectionButton>
    );
  };

  const getBackButton = () => {
    return (
      <SubSectionLink
        name='link'
        isUpdateMode={isUpdateMode}
        pageId={pageId}
        backButtonHide={backButtonHide}
      >
        {isUpdateMode ? (
          <Button
            color='red'
            label='Cancel'
            id='btn-cancel'
            disabled={processing}
            type='text'
            {...prevButtonTheme}
            handleButtonClick={
              isList
                ? () => handleListSubmit('CANCEL_UPDATE')
                : () => handleSectionContinue('', 'CANCEL_UPDATE', isList)
            }
            onFocus={handleButtonFocus}
            themeConfiguration={getThemeConfiguration(props, 'prev')}
            ariaLabel={getAriaLabel('cancel')}
          />
        ) : (
          !backButtonHide && (
            <Button
              shape='rounded'
              label={prevButtonText}
              id={`btn-prev-${toDashCase(prevButtonText)}`}
              type='text'
              disabled={isPopUpOpen}
              color={primaryButton.color}
              handleButtonClick={prevButtonAction}
              {...prevButtonTheme}
              onFocus={handleButtonFocus}
              themeConfiguration={getThemeConfiguration(props, 'prev')}
            />
          )
        )}
      </SubSectionLink>
    );
  };

  // Configs for handling pages with single button
  if (singleButtonPage(pageId) && !singleButtonExceptions()) {
    return (
      <FullWidthButton
        name='full-width-button'
        fullWidthBtnTheme={fullWidthBtnTheme}
        pageId={pageId}
      >
        {!otherNextButtonHidden && (
          <Button
            shape='rectangle'
            label={otherNextButtonText}
            id={`other-next-btn-${otherNextButtonText.replace(' ', '-')}`}
            color={primaryButton.color}
            {...nextButtonTheme}
            themeConfiguration={get(fullWidthBtnTheme, 'themeConfiguration', {})}
            handleButtonClick={() => handleOtherNextButtonClick(copyAppConfig?.redirectUrl)}
            onFocus={handleButtonFocus}
            disabled={isChallengeBtnDisabled || !enableContinue || processing || isPopUpOpen}
          />
        )}
        {!nextButtonHide && (
          <Button
            label={getSingleButtonLabel()}
            id={`btn-${toDashCase(getSingleButtonLabel())}`}
            color={primaryButton.color}
            disabled={isChallengeBtnDisabled || !enableContinue || processing || isPopUpOpen}
            {...nextButtonTheme}
            handleButtonClick={() => {
              if (pageId === 'login') {
                handleAuthSubmit();
              } else if (pageId === 'review') {
                handleNextButton(pageId);
              } else if (pageId === 'signature' && redirectUrl) {
                window.location.replace(redirectUrl);
              } else {
                handleSectionContinue(nextButtonId, '', nextButtonAttemptCount);
              }
            }}
            onFocus={handleButtonFocus}
            themeConfiguration={get(fullWidthBtnTheme, 'themeConfiguration', {})}
            description={nextButtonDescription}
            buttonDescriptionTheme={buttonDescriptionTheme}
          />
        )}
      </FullWidthButton>
    );
  }

  // Handles List Add Button
  if (listId) {
    // for Nationwide we use 'listAddButtonLabel' that is sent from Back end
    return (
      <Button
        label={listAddButtonLabel || 'Add'}
        type='subsection'
        disabled={!enableAdd}
        handleButtonClick={() => handleListAdd(isNestedQ, parentListIndex)}
        onFocus={handleListActionFocus}
        themeConfiguration={get(
          listItemCardTheme,
          'themeConfiguration',
          getThemeConfiguration(props, 'add'),
        )}
        addBtnTheme={listAddBtnTheme}
        exactBtnTheme={exactBtnTheme}
      />
    );
  }

  if (!nextButtonHide || !backButtonHide || isUpdateMode)
    return (
      <PageButton
        pageLayout={pageLayout}
        showInlineButtons={showInlineButtons}
        maxWidth={maxWidth}
        name='action-buttons'
        isLastSection={isLastSection}
        showArrowButton={showArrowButton}
      >
        <SubSection showInlineButtons={showInlineButtons} name='subsection'>
          {docWidth <= 480 ? (
            <>
              {getContinueButton()}
              {getBackButton()}
            </>
          ) : (
            <>
              {getBackButton()}
              {getContinueButton()}
            </>
          )}
        </SubSection>
      </PageButton>
    );
  return null;
};

const mapStateToProps = (state, props) => {
  const { isLoading, loadingSection } = getLoaders(state);
  const { otherParams, questionList } = getCurrentQuestionSet(state);
  const listSelector = getListProps(state);
  const { activeSubsectionId, listEditIndex, listEditQId } = state.questions;

  const { sectionData } = props;
  const sectionIndex = sectionData ? sectionData.length - 1 : props.sectionIndex;

  // If id is not present then takes the path
  const id =
    get(props, 'match.params.id', null) ||
    get(props, 'match.url', '').replace('/', '') ||
    activeSubsectionId;

  // Section / Breadcrumb Level Continue Status
  const { enableContinue: sectionContinue } = getContinueState(
    state,
    sectionIndex,
    activeSubsectionId,
  );
  let enableContinue = getEnableContinueBreadCrumb(state, id, props.mode);
  const isPopUpOpen = get(state, 'questions.popupDetails.show', false);
  const copyAppConfig = get(state, 'questions.copyAppConfig', false);
  const screenViewport = get(state, 'meta.screenViewport');

  const currentStatus = get(otherParams, 'current_status', '');
  const showEditPageFlag = get(otherParams, 'show_edit_page_flag', false);
  const prevButtonText = get(otherParams, 'prev_button_text', 'Back');
  const nextButtonText = get(otherParams, 'next_button_text', '');
  const otherNextButtonText = get(otherParams, 'other_next_button_text', '');
  const nextButtonId = get(otherParams, 'next_button_id', null);
  const redirectUrl = get(otherParams, 'next_button_redirect_url', '');

  // Config for Button Events (e.g scroll to top on click)
  let prevBtnScrollTop = false;
  const prevButtonEvent = get(otherParams, 'buttons.prev.event');
  if (prevButtonEvent) {
    const { type, scrollTo } = prevButtonEvent;
    if (type === 'scroll' && scrollTo === 'top') {
      prevBtnScrollTop = true;
    }
  }

  // single button description
  const nextButtonDescription = get(otherParams, 'buttons.next.description', '');

  const { isList, listDisplay } = listSelector(sectionIndex);
  const isUpdateMode = showEditPageFlag;

  const isProcessing = () => {
    if (singleButtonPage(props.pageId)) {
      return isLoading;
    }
    return isLoading && loadingSection === sectionIndex;
  };

  let processing = isProcessing();

  // check for custom role & custom role button enability
  const { csrConfig = {}, requoteCsrConfig = {}, role } = state.questions;

  const anyCsrSectionEnabled = Object.keys(csrConfig).some((section) =>
    get(csrConfig, [section, 'enable'], false),
  );
  const anyRequoteSectionEnabled = Object.keys(requoteCsrConfig).some((section) =>
    get(requoteCsrConfig, [section, 'enable'], false),
  );
  const isCsrSectionBtnEnabled =
    (csrConfig && anyCsrSectionEnabled) || (requoteCsrConfig && anyRequoteSectionEnabled);

  if (isCustomRole(role) && isCsrSectionBtnEnabled) {
    enableContinue = false;
    processing = false;
  }

  // Hide page cta buttons, when any of the requote page buttons questions are enabled
  const isRequoteScreen = activeSubsectionId?.toLowerCase() === 'applicationrequotebreadcrumb';
  const showArrowButton = isRequoteScreen && nextButtonText.toUpperCase() !== 'CONTINUE';

  return {
    enableContinue,
    sectionContinue,
    isList,
    listDisplay,
    processing,
    currentStatus,
    isLastSection: get(otherParams, 'section_status', 1),
    otherParams,
    isUpdateMode,
    prevButtonText,
    nextButtonId,
    nextButtonText,
    showArrowButton,
    nextButtonDescription,
    otherNextButtonText,
    redirectUrl,
    prevBtnScrollTop,
    questionList,
    isPopUpOpen,
    listEditIndex,
    listEditQId,
    copyAppConfig,
    screenViewport,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { sectionData, onContinue, questionIds, listId } = props;
  const sectionIndex = sectionData ? sectionData.length - 1 : props.sectionIndex;
  return {
    handleAuthSubmit: () => {
      dispatch(submitAuthQuestion());
    },
    handleSectionContinue: (buttonId, action, nextButtonAttemptCount, isList = false) => {
      let actionProps = {};
      if (props.actionProps) actionProps = props.actionProps;
      if (onContinue) onContinue(sectionIndex);
      // track button clicks for challenge page
      let attempt = 0;
      const activeSection = sectionData ? sectionData[sectionIndex] : {};
      const currentStatus = get(activeSection, 'otherParams.current_status');
      const illustration = get(activeSection, 'otherParams.illustration', '');
      if (
        currentStatus === 'challenge' &&
        nextButtonAttemptCount !== undefined &&
        typeof nextButtonAttemptCount === 'number'
      ) {
        attempt = nextButtonAttemptCount + 1;
        SessionStorageServices.setLocalValue('attempt', attempt); // persist attempts to handle page refresh
      }
      const otherParams = {
        actionProps,
        isList,
        attempt,
        illustration,
        uspsNextPage: true,
        ...(buttonId && { onClick: buttonId }),
      };
      dispatch(submitSectionQuestion(sectionIndex, otherParams, action));
    },
    handleListAdd: (isNestedQ, parentListIndex) => {
      dispatch(
        addListItem(
          sectionIndex,
          null,
          questionIds,
          listId,
          `list-add-form-btn-${listId}`,
          parentListIndex,
          isNestedQ,
        ),
      );
      dispatch(setOuterListActionButton(true, null));
    },
    handleListSubmit: (action) => {
      dispatch(submitListAnswers(sectionIndex, action, listId));
    },
    handleBackLink: () => {
      dispatch(goToPreviousBreadCrumb(sectionIndex));
    },
    handleNextButton: () => {
      dispatch(
        getNextPage({
          next_page_flag: 1,
          review_completed: true,
        }),
      );
    },
    handleOtherNextButtonClick: async (redirectUrl) => {
      window.open(redirectUrl, '_blank');
    },
  };
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(ActionButtons));
